import {
  browserTracingIntegration,
  captureConsoleIntegration,
  init,
  makeFetchTransport,
  moduleMetadataIntegration,
  makeMultiplexedTransport,
  globalHandlersIntegration,
  httpClientIntegration,
} from '@sentry/angular';
import { reactRouterV7BrowserTracingIntegration } from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const SENTRY_DSN = PFLM.SENTRY_DSN;
const DOMAIN = PFLM.DOMAIN;

const initSentry = () => {
  const EXTRA_KEY = 'ROUTE_TO';

  const transport = makeMultiplexedTransport(makeFetchTransport, args => {
    const event = args.getEvent();

    if (event && event.extra && EXTRA_KEY in event.extra && Array.isArray(event.extra[EXTRA_KEY])) {
      return event.extra[EXTRA_KEY];
    }

    return [];
  });

  const tracePropagationTarget = new RegExp(`^${DOMAIN}`);

  init({
    dsn: SENTRY_DSN,
    integrations: [
      moduleMetadataIntegration(),
      browserTracingIntegration(),
      captureConsoleIntegration({ levels: ['error'] }),
      reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      globalHandlersIntegration({ onerror: true, onunhandledrejection: true }),
      httpClientIntegration(),
    ],
    tracesSampleRate: 0.3,
    tracePropagationTargets: [tracePropagationTarget],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.3,
    transport,
    beforeSend: event => {
      if (event?.exception?.values?.[0].stacktrace?.frames) {
        const frames = event.exception.values[0].stacktrace.frames;
        const routeTo = frames
          .filter(frame => frame.module_metadata && frame.module_metadata.dsn)
          .map(v => v.module_metadata)
          .slice(-1);

        if (routeTo.length) {
          event.extra = {
            ...event.extra,
            [EXTRA_KEY]: routeTo,
          };
        }
      }

      return event;
    },
  });
};

export { initSentry };
